import { render, staticRenderFns } from "./ElderList.vue?vue&type=template&id=5e936c0d&scoped=true"
import script from "./ElderList.vue?vue&type=script&lang=js"
export * from "./ElderList.vue?vue&type=script&lang=js"
import style0 from "./ElderList.vue?vue&type=style&index=0&id=5e936c0d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e936c0d",
  null
  
)

export default component.exports